import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import TranslatedCopy from '../../intl/translated-copy';

const BookerFormField = ({
  children,
  className,
  labelBtnCopyID,
  labelCopyID,
  onLabelBtnClick,
  layoutCols,
}) => {
  const classes = cx({
    'BookerFormField': true,
    'is-columns': layoutCols,
  }, className);

  return (
    <div className={ classes }>
      { labelCopyID ?
        <div className='BookerFormField-label u-textUppercase'>
          { labelCopyID ? <TranslatedCopy copyID={ labelCopyID } /> : null }
          { labelBtnCopyID && onLabelBtnClick ?
            <button className='BookerFormField-labelBtn' onClick={ onLabelBtnClick }>
              <TranslatedCopy copyID={ labelBtnCopyID } />
            </button> : null }
        </div> : null }
      { children }
    </div>
  );
};

BookerFormField.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.element,
  ]),
  labelBtnCopyID: PropTypes.string,
  labelCopyID: PropTypes.string,
  onLabelBtnClick: PropTypes.func,
  layoutCols: PropTypes.bool,
};

BookerFormField.defaultProps = {
  layoutCols: false,
};

export default BookerFormField;
